"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var material_1 = require("@mui/material");
var Box_1 = __importDefault(require("@mui/material/Box"));
var TopBorderBox = (0, material_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: '#E0E0E0',
    });
});
/**
 * a Drawer CTA sits at the bottom of a Drawer
 *
 * Creates a Wrapper to be used with DrawerCTAContent
 */
var Component = function (p) { return (Preact.h(TopBorderBox, { sx: __assign({ backgroundColor: 'background.default', borderRadius: 0 }, p.sx) }, p.children)); };
exports.Component = Component;
exports.Component.displayName = 'DrawerCtaContainer';
